import { motion } from "framer-motion";
import styled from "styled-components/macro";

import { TitleH2 } from "../../styles/sharedStyles";

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  
  @media (max-width: 979px) {
    flex-direction: column;
    gap: 32px;
  }
`

export const TitleBlock = styled.div`
  width: 424px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  
  @media (max-width: 979px) {
    width: 100%;
    max-width: 100%;
    align-items: center;
  }
`

export const Title = styled(TitleH2)`
  margin-bottom: 24px;
  text-align: left;
`

export const TextWithLink = styled.p`
  font-size: 18px;
  
  a {
    color: #55749F;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`

export const AccordionContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 979px) {
    width: 100%;
  }
`

export const AccordionItem = styled.div`
  overflow: hidden;
  width: 100%;
`

export const QuestionButton = styled.button`
  width: 100%;
  background-color: transparent;
  border: 1px solid #B4B4B4;
  border-radius: 50px;
  padding: 26px 40px;
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: background-color 0.2s;
  box-sizing: border-box;
  letter-spacing: -0.02em;
  
  &:hover {
    background-color: rgba(239, 239, 239, 0.5);
  }
    
  @media (max-width: 979px) {
    padding: 16px 14px;
    font-size: 16px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
`

export const Circle = styled.div`
  width: 8px;
  height: 8px;
  background-color: #55749F;
  border-radius: 50%;
  margin-right: 8px;
`

export const ToggleIcon = styled.div<{ active: boolean }>`
  min-width: 14px;
  min-height: 14px;
  transform: ${({ active }) => (active ? "rotate(45deg)" : "rotate(0deg)")};
  transition: transform 0.2s ease;
  margin-left: auto;
  
  svg {
    display: block;
  }
  
  svg path {
    stroke: #A7A7A7;
  }
`

export const AnswerContainer = styled(motion.div)`
  overflow: hidden;
  background-color: #fff;
  border-radius: 24px;
  margin-top: 14px;
`

export const AnswerContent = styled.div`
  padding: 26px 40px;
  font-size: 18px;
  line-height: 140%;
    
  @media (max-width: 979px) {
    padding: 32px;
    font-size: 15px;
  }
`
